module.exports = __webpack_public_path__ + "img/mobile-small.f2824901.svg";